export const zeytalVariablesFigmaPluginId = "1502811310740851813";

export const projectTokenHeaderName = "X-Zeytal-Project-Token";
export const figmaPluginIdHeaderName = "X-FIGMA-PLUGIN-ID";

export const zeytalAPIBaseUrl = "https://api.zeytal.com";

export const lineEndSignature = "xxx-l_e-xxx";
